import React, { Component } from 'react';
import './Collaps.css';

import svgArrowD from '../Img/icon/arrow-d.svg';

class Collaps extends Component {
	constructor(props) {
		super(props);
		this.state = { isOpen: false };

		this.toggel = this.toggel.bind(this);
	}

	toggel() {
		this.setState({ isOpen: !this.state.isOpen });
	}

	render() {
		let dText;
		if (this.state.isOpen) {
			dText = <React.Fragment> {this.props.children} </React.Fragment>
		}
		return (
			<React.Fragment>
				<div onClick={this.toggel} to="#" className="c-triger">
					<img src={svgArrowD} alt=""/>	Докладніше...
				</div>
				{dText}
			</React.Fragment>
		);
	}
}

export default Collaps;


// WEBPACK FOOTER //
// ./src/Components/Collaps.jsx